import FormSelectView from './src/formSelectView.vue';

/* istanbul ignore next */
FormSelectView.install = function(Vue) {
    Vue.component(FormSelectView.name, FormSelectView);
};

export default FormSelectView;